function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M13.25 12h-7.5C4.785 12 4 11.215 4 10.25v-4.5C4 4.785 4.785 4 5.75 4h7.5c.965 0 1.75.785 1.75 1.75v4.5c0 .965-.785 1.75-1.75 1.75zm-7.5-6.5a.25.25 0 00-.25.25v4.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-7.5zM13.25 28h-7.5C4.785 28 4 27.215 4 26.25v-10.5c0-.965.785-1.75 1.75-1.75h7.5c.965 0 1.75.785 1.75 1.75v10.5c0 .965-.785 1.75-1.75 1.75zm-7.5-12.5a.25.25 0 00-.25.25v10.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-10.5a.25.25 0 00-.25-.25h-7.5zM26.25 28h-7.5c-.965 0-1.75-.785-1.75-1.75v-4.5c0-.965.785-1.75 1.75-1.75h7.5c.965 0 1.75.785 1.75 1.75v4.5c0 .965-.785 1.75-1.75 1.75zm-7.5-6.5a.25.25 0 00-.25.25v4.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-7.5zM26.25 18h-7.5c-.965 0-1.75-.785-1.75-1.75V5.75c0-.965.785-1.75 1.75-1.75h7.5c.965 0 1.75.785 1.75 1.75v10.5c0 .965-.785 1.75-1.75 1.75zm-7.5-12.5a.25.25 0 00-.25.25v10.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25V5.75a.25.25 0 00-.25-.25h-7.5z"
}));

var SvgIcNavDashboardActive = function SvgIcNavDashboardActive(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 31
  }, props), _ref);
};

export default __webpack_public_path__ + "c766efca34be832791e0880a02e8e32b.svg";
export { SvgIcNavDashboardActive as ReactComponent };